import { ALLOWED_COLORS, ALLOWED_SIZES, ALLOWED_WEIGHTS, sanitizeAllowedString, sanitizeBindable, sanitizeFormattableBindable, sanitizeString } from './helpers';
export function sanitizeText(el) {
  const text = sanitizeFormattableBindable(el.text, sanitizeString);
  if (!text) return null;
  return {
    type: 'Text',
    text,
    size: sanitizeBindable(el.size, v => sanitizeAllowedString(v, ALLOWED_SIZES)),
    weight: sanitizeBindable(el.weight, v => sanitizeAllowedString(v, ALLOWED_WEIGHTS)),
    color: sanitizeBindable(el.color, v => sanitizeAllowedString(v, ALLOWED_COLORS))
  };
}